import * as z from "zod"

export const WorkspaceUserPropertiesDbModel = z.object({
  workspaceId: z.string(),
  userId: z.string(),
  lastUsed: z.coerce.date(),
})
